export default __webpack_public_path__ + "static/media/feather _ chevron-down.d123346f.svg";